import type { NotificationDto } from "../data";

const CATEGORIES = ["ALERT", "SYSTEM", "SUBSCRIPTION", "MAINTENANCE"] as const;

function isoDaysAgo(days: number): string {
  const date = new Date("2026-02-10T09:00:00.000Z");
  date.setUTCDate(date.getUTCDate() - days);
  return date.toISOString();
}

export const notificationFixtures: NotificationDto[] = Array.from(
  { length: 32 },
  (_, index) => {
    const category = CATEGORIES[index % CATEGORIES.length]!;
    const number = index + 1;
    return {
      id: `notification-${String(number).padStart(2, "0")}`,
      titleEn: `${category} update #${number}`,
      titleAr: `تحديث ${number}`,
      bodyEn: `Details for ${category.toLowerCase()} notification number ${number}.`,
      bodyAr: `تفاصيل الإشعار رقم ${number}.`,
      category,
      isRead: number % 3 === 0,
      createdAt: isoDaysAgo(index),
      linkPath: category === "SUBSCRIPTION" ? "/subscriptions" : null,
    };
  },
);
